export default [{
        path: "/ventas-nacionales/resumen-ventas",
        name: "ventas-nacionales-resumen-ventas",
        component: () =>
            import ("@/views/pages/ventasNacionales/resumen/ResumenVentas.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas Nacionales',
            action: 'ver-ventas-nacionales-resumen-ventas',
            pageTitle: "Resumen Ventas",
            breadcrumb: [
                { text: "Ventas Nacionales" },
                { text: "Resumen Ventas", active: true }
            ]
        }
    },
    {
        path: "/ventas-nacionales/detalles/ventas-canal",
        name: "ventas-nacionales-detalles-ventas-canal",
        component: () =>
            import ("@/views/pages/ventasNacionales/detalles/VentasCanal.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas Nacionales',
            action: 'ver-ventas-nacionales-detalle-venta-canal',
            pageTitle: "Ventas Por Canal",
            breadcrumb: [
                { text: "Resumen Ventas" },
                { text: "Detalles" },
                { text: "Ventas Por Canal", active: true }
            ]
        }
    },
    {
        path: "/ventas-nacionales/detalles/ventas-cliente",
        name: "ventas-nacionales-detalles-ventas-cliente",
        component: () =>
            import ("@/views/pages/ventasNacionales/detalles/VentasCliente.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas Nacionales',
            action: 'ver-ventas-nacionales-detalle-venta-cliente',
            pageTitle: "Ventas Por Cliente",
            breadcrumb: [
                { text: "Resumen Ventas" },
                { text: "Detalles" },
                { text: "Ventas Por Cliente", active: true }
            ]
        }
    },
    {
        path: "/ventas-nacionales/detalles/ventas-item",
        name: "ventas-nacionales-detalles-ventas-item",
        component: () =>
            import ("@/views/pages/ventasNacionales/detalles/VentasItem.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas Nacionales',
            action: 'ver-ventas-nacionales-detalle-venta-item',
            pageTitle: "Ventas Por Item",
            breadcrumb: [
                { text: "Resumen Ventas" },
                { text: "Detalles" },
                { text: "Ventas Por Item", active: true }
            ]
        }
    },
    {
        path: "/ventas-nacionales/detalles/rentabilidad-canal",
        name: "ventas-nacionales-detalles-rentabilidad-canal",
        component: () =>
            import (
                "@/views/pages/ventasNacionales/detalles/RentabilidadCanal.vue"
            ),
        meta: {
			title: 'i18n:',
            resource: 'Ventas Nacionales',
            action: 'ver-ventas-nacionales-detalle-rentabilidad-canal',
            pageTitle: "Rentabilidad Por Canal",
            breadcrumb: [
                { text: "Resumen Ventas" },
                { text: "Detalles" },
                { text: "Rentabilidad Por Canal", active: true }
            ]
        }
    },
    {
        path: "/ventas-nacionales/detalles/rentabilidad-autoservicio",
        name: "ventas-nacionales-detalles-rentabilidad-autoservicio",
        component: () =>
            import (
                "@/views/pages/ventasNacionales/detalles/RentabilidadAuto.vue"
            ),
        meta: {
			title: 'i18n:',
            resource: 'Ventas Nacionales',
            action: 'ver-ventas-nacionales-detalle-rentabilidad-autoservicio',
            pageTitle: "Rentabilidad Por AutoServicio",
            breadcrumb: [
                { text: "Resumen Ventas" },
                { text: "Detalles" },
                { text: "Rentabilidad Por AutoServicio", active: true }
            ]
        }
    },
];
